import { makeStyles } from "@material-ui/core/styles";
import {
  DATA_VIEW_EMBEDDED_CONTROLS_HEIGHT_PX,
  DATA_VIEW_MIN_VIDEO_HEIGHT_PX,
} from "../DataView/sequencerDataViewLayout";

const PlayerView = makeStyles((theme) => ({
  // sequencer player styles
  playerButton: {
    backgroundColor: "#1B1D28 !important",
    borderRadius: "8px !important",
    padding: "8px !important",
    height: "26px !important",
    width: "26px !important",
  },
  sequencerPlayerRoot: {
    backgroundColor: "#252A38",
    width: "100%",
    height: "100%",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
  },
  sequencerPlayerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    height: "53px",
    boxSizing: "border-box",
  },

  playerContainer: {
    position: "relative",
    width: "100%",
    height: "calc(100% - 50px)",
  },
  sequencerPlayerRootEmbedded: {
    backgroundColor: "#252a38",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  playerContainerEmbedded: {
    position: "relative",
    width: "100%",
    flex: 1,
    minHeight: `${DATA_VIEW_MIN_VIDEO_HEIGHT_PX}px`,
    minWidth: 0,
  },
  backButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px !important",
    },
  },
  sequencerTitle: {
    fontWeight: "500",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "16px !important",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "18px !important",
    },
  },
  sequencerVideoPlayerContainer: {
    height: "calc(100% - 80px)",
    position: "relative",
    backgroundColor: "black",
  },
  sequencerVideoControls: {
    padding: "8px",
    height: "max-content",
    boxSizing: "border-box",
    flexShrink: 0,
  },
  sequencerVideoControlsEmbedded: {
    boxSizing: "border-box",
    flexShrink: 0,
    height: `${DATA_VIEW_EMBEDDED_CONTROLS_HEIGHT_PX}px`,
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  embeddedSeekbarRow: {
    height: "28px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  embeddedTransportRow: {
    height: "32px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  playlistText: {
    color: "#B1B5C9",
    fontSize: "12px",
    marginRight: "8px",
  },
  totalDuration: {
    color: "#B1B5C9",
  },
  // task template and shots styles
  taskAndShotsRoot: {
    backgroundColor: theme.palette.secondary.light,
    padding: "5px",
    paddingTop: "0px",
    height: "100%",
    overflowY: "auto",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  taskAndShotsContainer: {
    backgroundColor: "#1B1D28",
    padding: "4px",
    height: "calc(100% - 60px)",
    boxSizing: "border-box",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
    width: "100%",
  },
  lastSyncText: {
    marginTop: "10px",
    fontSize: "12px",
    color: theme.palette.text.tertiary,
  },
  syncAndCompareButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "60px",
    boxSizing: "border-box",
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  syncWithLatestButtons: {
    backgroundColor: theme.palette.primary.main,
    padding: "6px 10px",
    width: "100%",
    fontSize: "12px",
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  //task template styles
  singleTaskTemplate: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px 8px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  taskTemplateTitle: {
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },
  versionCount: {
    color: theme.palette.text.tertiary,
    [theme.breakpoints.down(1537)]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.up(1537)]: {
      fontSize: "12px !important",
    },
  },

  // sequences overview styles
  singleSequenceContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#252A38",
    borderRadius: "5px",
    width: "100%",
  },
  commentsContainer: {
    height: "300px",
    overflowY: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down("xl")]: {
      height: "45vh",
    },
    [theme.breakpoints.down("lg")]: {
      height: "300px",
    },
    [theme.breakpoints.down("md")]: {
      height: "300px",
    },
  },
  commentsContainerEmbedded: {
    height: "100%",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  rightContainer: {
    height: "100%",
    width: "100%",
    overflowY: "auto",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
    zIndex: 1000,
  },
  button1: {
    backgroundColor: "#6C65D94D",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
    width: "47%",
  },
  button1type2: {
    backgroundColor: "#6C65D94D",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
  },
  button2: {
    backgroundColor: "#252A38",
    color: "#F9F9F9",
    borderRadius: "5px",
    padding: "8px 16px",
    fontSize: "14px",
    width: "47%",
  },
}));

export default PlayerView;
